import { createContext, useContext, useEffect, useState, createElement } from "react";
import { api } from "./api";
import { useAuth } from "./auth";

const BrandCtx = createContext(null);
const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const hexToHsl = (hex) => {
  const m = /^#?([0-9a-f]{6})$/i.exec(hex || "");
  if (!m) return null;
  const [r, g, b] = [0, 2, 4].map((i) => parseInt(m[1].slice(i, i + 2), 16) / 255);
  const max = Math.max(r, g, b), min = Math.min(r, g, b), l = (max + min) / 2, d = max - min;
  let h = 0, s = 0;
  if (d) {
    s = d / (1 - Math.abs(2 * l - 1));
    h = max === r ? ((g - b) / d) % 6 : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
    h = Math.round(h * 60 + 360) % 360;
  }
  return `${h} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
};

const apply = (b) => {
  let link = document.querySelector("link[rel='icon']");
  if (!link) { link = document.createElement("link"); link.rel = "icon"; document.head.appendChild(link); }
  link.href = b.favicon ? `${BACKEND}${b.favicon}` : "/favicon.ico";
  const hsl = hexToHsl(b.brand_accent);
  const root = document.documentElement.style;
  if (hsl) { root.setProperty("--primary", hsl); root.setProperty("--ring", hsl); }
  else { root.removeProperty("--primary"); root.removeProperty("--ring"); }
};

export function BrandProvider({ children }) {
  const { accountId } = useAuth();
  const [brand, setBrand] = useState({});
  useEffect(() => {
    if (!accountId) return undefined;
    const load = () => api.get("/branding").then(({ data }) => { setBrand(data); apply(data); }).catch(() => setBrand({}));
    load();
    window.addEventListener("branding-updated", load);
    return () => window.removeEventListener("branding-updated", load);
  }, [accountId]);
  return createElement(BrandCtx.Provider, { value: brand }, children);
}

export const useBrand = () => useContext(BrandCtx);

export const pageBannerKey = (pathname) => {
  const seg = pathname.split("/")[2];
  if (!pathname.startsWith("/app/") || !seg) return null;
  return seg === "settings" ? "settings_banner" : `banner_${seg.replace(/-/g, "_")}`;
};
